/* oxlint-disable typescript/no-unnecessary-condition -- LINTER migration follow up */
export class AssertionError extends Error {
  constructor(message: string, context: undefined | object) {
    let serializedContext: string | undefined;
    try {
      serializedContext = context ? JSON.stringify(context) : undefined;
    } catch (e) {
      serializedContext = `couldn't serialize context: ${e instanceof Error ? e.message : String(e)}`;
    }
    const errorMsg = serializedContext
      ? `assertion failed: ${message}, additional context: ${serializedContext}`
      : `assertion failed: ${message}`;

    super(errorMsg);
    this.name = this.constructor.name;
    this.cause = errorMsg;

    // Restore the prototype chain
    Object.setPrototypeOf(this, new.target.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
